module.exports = __webpack_public_path__ + "media/arrows/dropdown-arrow-e4913c61.svg";